const LoginErrors: Record<string, string> = {
	'user': 'Benutzer oder Passwort falsch',
	'firstPwsd': 'An Ihre Adresse wurde ein E-Mail geschickt.',
	'internalError': 'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an Ihren Systemadministrator.',
}

export function extractErrorFromUrl(url: String | undefined | null) {
	if (!url) return null;
	let posStartSearchParam = url.indexOf('?');
	let searchString = url.substring(posStartSearchParam, url.length);
	let searchParams = new URLSearchParams(searchString);
	let error = searchParams.get('error');
	return error && LoginErrors[error] || null;
}